// extracted by mini-css-extract-plugin
export var container = "breadcrumb-container-module--container--iTZdp";
export var breadcrumb = "breadcrumb-container-module--breadcrumb--cC13N";